import React from 'react';
import { isEmpty } from 'lodash';
import { Col, Row, ReduxForm } from 'angieslist-react-components';
import './EditLicenseInformation.scss';

type Props = {
  name: string,
  options: Array<{name: string, value: string}>
};

const LicenseOrgField = ({ name, options, ...props }: Props) => (
  <Row className="LicenseInformation-Edit--Row">
    <Col xs={12}>
      <Choose>
        <When condition={isEmpty(options)}>
          <ReduxForm.Input
            name={`additionalFields.${name}`}
            id={`EditOrCreateLicenseInformation--${name}`}
            label={name}
            type="text"
            {...props}
          />
        </When>
        <Otherwise>
          <ReduxForm.Input
            name={`additionalFields.${name}`}
            id={`EditOrCreateLicenseInformation--${name}`}
            label={name}
            type="select"
            {...props}
          >
            <option value="" />
            {options.map(option => (
              <option value={option.value}>{option.name}</option>
          ))}
          </ReduxForm.Input>
        </Otherwise>
      </Choose>
    </Col>
  </Row>);

export default LicenseOrgField;



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/LicenseOrgField.js